export default "__VITE_ASSET__C_gEEYZ7__"